import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userStr = localStorage.getItem("user");
  const location = useLocation();

  if (!userStr) {
    // 🔴 user login नहीं है
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);

    const isSelfieRoute = location.pathname === "/selfie-capture" || location.pathname === "/capture-selfie";

    // If user is not admin and has NO selfie path, they MUST go to selfie-capture
    if (user.role !== "admin" && !user.selfie && !isSelfieRoute) {
      return <Navigate to="/selfie-capture" replace />;
    }

    // If user already has a selfie path, don't let them go back to selfie-capture unless updating from profile
    if (user.role !== "admin" && user.selfie && isSelfieRoute && !location.search.includes("from=profile")) {
      return <Navigate to="/user-dashboard" replace />;
    }

  } catch (error) {
    console.error("Error parsing user data in ProtectedRoute", error);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
